import { isNumber } from 'radash';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { useOrganization } from './useOrganization';

const useFloatFormatter = () => {

    const intl = useIntl();
    const { organization } = useOrganization();

    /**
     * Formats a floating point value depending on the locale and the organization settings.
     */
    const formatFloat = useCallback((value: string | number) => {

        if (isNumber(value)) {
            value = value.toString();
        }

        let decimalSeparator = '.';
        const currentLocalDecimalSeparator = intl.formatNumber(1.1).charAt(1);;

        // Change the decimal separator if needed and if asked to by the organization settings
        if (decimalSeparator !== currentLocalDecimalSeparator && organization?.localeSpecificNumberFormat) {
            value = value.replace(decimalSeparator, currentLocalDecimalSeparator);
            decimalSeparator = currentLocalDecimalSeparator;
        } else {
            value = value.replace(',', decimalSeparator);
        }

        return value;

        // We only need one unchanging instance of this function
        //eslint-disable-next-line
    }, []);

    return { formatFloat };

};

export { useFloatFormatter };
